import { Box, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { FontFamily } from '@common/theming/Fonts';
import currency from '@common/utility/currency';
import { formatDate } from '@common/utility/datetime';
import { MSTrade, MSTradeTotals, MSTrades } from '@services/appsync/types';
import React, { useMemo } from 'react';
import { CURRENCY_OPTIONS } from '../../constants';
import { useStatementViewModel } from '../../models/StatementViewModel';

export const Activity: React.FC = () => {
  const statementViewModel = useStatementViewModel();

  const activity: MSTrades = useMemo(() => {
    const trades = statementViewModel.statement?.activity.trades;

    const items: MSTrade[] =
      trades?.items?.map((trade) => ({
        __typename: 'MSTrade',
        amount: trade.amount ? currency.format(trade.amount, CURRENCY_OPTIONS) : '',
        date: formatDate(new Date(`${trade.date}T00:00:00`), 'MMMM DD, YYYY'),
        description: trade.description,
        subscription_offer_name: trade.subscription_offer_name,
      })) ?? [];

    const totals: MSTradeTotals = {
      __typename: 'MSTradeTotals',
      amount: trades?.totals.amount ? currency.format(trades.totals.amount, CURRENCY_OPTIONS) : '',
    };

    return { __typename: 'MSTrades', items, totals };
  }, [statementViewModel.statement?.activity.trades]);
  if (!activity) return null;

  return (
    <Box w="full">
      <TableContainer>
        <Table px={'0px'} layout="fixed">
          <Thead>
            <Tr>
              <Td
                pl={'0px'}
                borderBottomStyle="none"
                fontSize="16px"
                fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                colSpan={6}>
                Monthly Activity
              </Td>
            </Tr>
            <Tr py="6px" borderBottom={'2px solid black'}>
              <Th
                fontWeight="normal"
                className="statement-table-header"
                lineHeight={1}
                fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                pl={'0px'}
                color="black">
                Date
              </Th>
              <Th
                fontWeight="normal"
                className="statement-table-header"
                colSpan={2}
                lineHeight={1}
                fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                color="black">
                Description
              </Th>
              <Th
                fontWeight="normal"
                className="statement-table-header"
                colSpan={2}
                lineHeight={1}
                fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                color="black">
                Investment
              </Th>
              <Th
                fontWeight="normal"
                className="statement-table-header"
                lineHeight={1}
                fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                color="black">
                Amount
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {activity?.items?.map((item, i) => (
              <Tr py="6px" key={`holding-${i}`}>
                <Td pl="4px">{item.date}</Td>
                <Td colSpan={2}>{item.description}</Td>
                <Td colSpan={2}>{item.subscription_offer_name}</Td>
                <Td>{item.amount}</Td>
              </Tr>
            ))}
            <Tr py="6px" backgroundColor="gray.50">
              <Td pl="4px" colSpan={5} fontFamily={FontFamily.HELVETICA_NOW_BOLD}>
                Total
              </Td>
              <Td fontFamily={FontFamily.HELVETICA_NOW_BOLD}>{activity.totals.amount}</Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};
